import React, { useState, useEffect } from "react";
import SiteMapAPI from "../api/SiteMapAPI";
import { useTranslation } from "react-i18next";

function SiteMap() {
  const { t, i18n } = useTranslation();
  const [details, setDetails] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await (i18n.language === 'en' ? SiteMapAPI.getSiteMapEn() : SiteMapAPI.getSiteMap());
        const data = response.data;
        setDetails(data);
      } catch (error) {
        console.log("fetDataError:", error);
      }
    };

    fetchData();
  }, [i18n.language]);

  return (
    <main className="site-main">
      {/* Banner */}
      <section className="banner bg-news-intro">
        <img
          className="banner-image w-full"
          src="/images/hero-image.jpeg"
          alt="Hero Banner"
        />
        <div className="headline text-center">
          <h1 className="headline-title text-3xl md:text-6xl font-bold text-white">
            {t('Site Map')}
          </h1>
        </div>
      </section>

      {/* Main Content */}
      <section className="content p-4 md:p-8 bg-gray-50">
        <div className="content-container box-news-container">
          <div className="content-header w-full">

            {/* Section: About Office */}
            <section className="about-office mb-6 md:mb-8">
              <div className="relative">
                {/* Vertical Line */}
                <div className="vertical-line absolute mb-2 left-4 md:left-8 lg:left-11 top-10 bottom-1 border-l-2 border-blue-900"></div>

                {details.length > 0 && details[0].Navigation && details[0].Navigation
                  .filter(item => item.active) // Filter only active items
                  .map((item, index) => (
                  <div key={item.url} className={`relative ${index !== 0 ? 'pl-4 md:pl-8 mb-6' : ''}`}>
                    {index !== 0 && (
                      <div className="mt-2 absolute pl-1 md:pl-5 lg:pl-8 left-1 flex items-center justify-center bg-white z-10">
                        {/* Outer Circle */}
                        <div className="w-4 h-4 border-2 border-blue-900 rounded-full flex items-center justify-center">
                          {/* Inner Circle */}
                          <div className="w-2 h-2 bg-blue-900 rounded-full"></div>
                        </div>
                      </div>
                    )}

                    <div
                      className={`section-title flex items-center mt-5 ${index === 0 ? 'text-xl md:text-3xl' : 'text-lg md:text-xl'} text-blue-900`}
                    >
                      {/* Title */}
                      <a
                        href={item.url}
                        className={`font-bold whitespace-nowrap ${index === 0 ? 'border-b-2 border-blue-900' : 'pl-4 md:pl-4 lg:pl-6'}`}
                      >
                        {t(item.title)}
                      </a>
                      {/* Horizontal Line */}
                      <div className={`${index === 0 ? '' : 'flex-grow h-[1px] ml-4 bg-gray-300'}`}></div>
                    </div>
                    {item.children && item.children.length > 0 && (
                      <ul className="section-list pl-4 md:pl-8">
                        {item.children
                          ?.filter((child) => child.active) // Filter only active items
                          .map((child, idx) => (
                            <li
                              key={`${child.url}-${idx}`}
                              className="section-item flex-col sm:flex md:flex-row items-start justify-between pl-1 sm:pl-4 md:pl-10 mb-6 mt-6"
                            >
                              {/* Left Column */}
                              <div className="item-title text-black flex-1 lg:max-w-[45%]">
                                {(!child.data?.column || child.data.column === 0) && (
                                  <>
                                    <a href={child.url} className="font-bold text-lg">{t(child.title)}</a>
                                    {/* Display sub-items */}
                                    {child.children && child.children.length > 0 && (
                                      <ul className="list-outside list-disc ml-6 mt-2 text-gray-600">
                                        {child.children.map((subChild, subIdx) => (
                                          <li key={`${subChild.url}-${subIdx}`} className="mt-1 ml-5">
                                            <a href={subChild.url}>{t(subChild.title)}</a>
                                          </li>
                                        ))}
                                      </ul>
                                    )}
                                  </>
                                )}
                              </div>

                              {/* Right Column */}
                              <div className="item-title text-black flex-1 min-w-[40%]">
                                {item.children?.filter((subChild) => subChild.data?.column === 1)[idx] && (
                                  <>
                                    <a
                                      href={item.children.filter((subChild) => subChild.data?.column === 1)[idx]?.url}
                                      className="ml-5 md:ml-0 text-lg"
                                    >
                                      {t(item.children.filter((subChild) => subChild.data?.column === 1)[idx]?.title)}
                                    </a>
                                    {/* Display sub-items */}
                                    {item.children.filter((subChild) => subChild.data?.column === 1)[idx]?.children &&
                                      item.children
                                        .filter((subChild) => subChild.data?.column === 1)[idx]
                                        ?.children.length > 0 && (
                                        <ul className="list-outside list-disc ml-6 mt-2 text-gray-600">
                                          {item.children
                                            .filter((subChild) => subChild.data?.column === 1)[idx]
                                            ?.children.map((subSubChild, subIdx) => (
                                              <li key={`${subSubChild.url}-${subIdx}`} className="mt-1 ml-7 md:ml-5">
                                                <a href={subSubChild.url}>{t(subSubChild.title)}</a>
                                              </li>
                                            ))}
                                        </ul>
                                      )}
                                  </>
                                )}
                              </div>
                            </li>
                          ))}
                      </ul>
                    )}
                  </div>
                  // </div>
                ))}
              </div>
            </section>
          </div>
        </div>
      </section>
    </main>
  );
}

export default SiteMap;